<div class="post-signup-container">
    <beaconstac-wait-loader
        *ngIf="isLoading"
        class="beaconstac-overlay full-layout"
    ></beaconstac-wait-loader>

    <div *ngIf="!isLoading && cardUrl" class="card-container">
        <div class="card-content">
            <iframe #cardPreview 
                [src]="cardUrl | getSafeUrl" 
                class="card-preview-frame" 
                sandbox="allow-scripts allow-same-origin allow-storage-access-by-user-activation" 
                allow="geolocation"
                referrerpolicy="no-referrer"
                title="Digital Business Card Preview">
            </iframe>
        </div>
    </div>

    <mobile-drawer [isDrawerOpen]="isDrawerOpen" (onOutsideClick)="onDrawerOutsideClick()" [isFullScreen]="false" [isDraggable]="true" [(isMinimized)]="isDrawerMinimized">
        <div class="drawer-content" [class.minimized]="isDrawerMinimized">
            <div class="drawer-full-content" [class.hidden]="isDrawerMinimized">
                <h3 class="deawer-heading">Your card is ready!</h3>
                <p class="drawer-description">Add it to your phone's home screen to share the card easily on the go.</p>
            </div>
            <div class="action-buttons" [class.minimized]="isDrawerMinimized">
                <button class="btn btn-primary" (click)="addToHomescreen()">
                    Add to Homescreen
                </button>
                <button class="btn btn-secondary" (click)="goToDashboard()" *ngIf="!isDrawerMinimized">
                    Go to Dashboard
                </button>
            </div>
        </div>
    </mobile-drawer>

    <ios-install-drawer
        *ngIf="showIosInstallDrawer"
        [showIosInstallDrawer]="showIosInstallDrawer"
        (closeIosInstallDrawer)="closeIosInstallDrawer()"
    ></ios-install-drawer>
</div>